module.exports = __webpack_public_path__ + "img/3.9f92ca7f.png";